// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__6T5N_","mainMenu":"Header_mainMenu__l32mC","bayernMenu":"Header_bayernMenu__llxPL","open":"Header_open__mNWou"};